import {useQuery} from '@tanstack/react-query'
import {useServices} from '@/services/context'
import {useAuth} from '@/contexts/auth-context'
import {permissions} from '@/lib/permissions'
import {RehireReviewStatus} from '@/types/rehire-review'

/**
 * Pending-count badge for the line-manager-scoped rehire-review queue. Used on
 * the My IAM sidebar. Returns 0 when the current user lacks
 * {@code rehire-review:list-mine} so the badge stays hidden for non-managers.
 */
export function usePendingMineRehireReviewCount() {
    const services = useServices()
    const {hasPermission} = useAuth()
    const enabled = hasPermission(permissions.rehireReview.listMine)

    return useQuery({
        queryKey: ['rehire-review-count', 'pending', 'mine'],
        queryFn: () => services.rehireReview.countMine(RehireReviewStatus.PENDING),
        enabled,
        refetchInterval: 60000,
    })
}
